// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../fonts/Vazirmatn-Variable.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'PublicFont';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
}

* {
    font-family: PublicFont, Tahoma, sans-serif;
    scrollbar-width: thin;
    scrollbar-color: #6c7ae0 #f0f0f0;
}

*::-webkit-scrollbar {
    width: 12px;
}

*::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 10px;
}

*::-webkit-scrollbar-thumb {
    background-color: #6c7ae0;
    border-radius: 20px;
    border: 2px solid #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/font.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,4DAA+D;IAC/D,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAI3C,qBAAqB;IACrB,gCAAgC;AAJpC;;AAOA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B","sourcesContent":["@font-face {\n    font-family: 'PublicFont';\n    src: url('./../fonts/Vazirmatn-Variable.woff2') format('woff2');\n    font-weight: 100 900;\n    font-style: normal;\n    font-display: swap;\n}\n\n* {\n    font-family: PublicFont, Tahoma, sans-serif;\n}\n\n* {\n    scrollbar-width: thin;\n    scrollbar-color: #6c7ae0 #f0f0f0;\n}\n\n*::-webkit-scrollbar {\n    width: 12px;\n}\n\n*::-webkit-scrollbar-track {\n    background: #f0f0f0;\n    border-radius: 10px;\n}\n\n*::-webkit-scrollbar-thumb {\n    background-color: #6c7ae0;\n    border-radius: 20px;\n    border: 2px solid #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
